import { useState } from "react";
import { Button } from "antd";
import Main from "../../components/layout/Main";
import { Tabs } from "antd";
import ActiveDevicesIndex from "../Devices/Index";
import PlatformPolicies from "../PlatformPolicies/Index";
import FeedbackIndex from "../FeedbackSubmit/Index";

const Settings = () => {
  const [activeKey, setActiveKey] = useState("1");

  const tabs = [
    { key: "1", label: "Active Device", content: <ActiveDevicesIndex /> },
    { key: "2", label: "Platform Policies", content: <PlatformPolicies /> },
    { key: "3", label: "Feedbacks", content: <FeedbackIndex /> },
  ];

  return (
    <Main>
      <div className="section-main">
        {/* Button headers */}
        <div
          className="button-tabs-header"
          style={{ display: "flex", gap: "12px", marginBottom: "16px" }}
        >
          {tabs.map((tab) => (
            <Button
              key={tab.key}
              onClick={() => setActiveKey(tab.key)}
              className={`button-tab_newm ${
                activeKey === tab.key ? "button-tab_newm_active" : ""
              }`}
            >
              {tab.label}
            </Button>
          ))}
        </div>

        {/* Content */}
        <div className="button-tabs-content">
          {tabs.find((tab) => tab.key === activeKey)?.content}
        </div>
      </div>
    </Main>
  );
};

export default Settings;
